import { render, staticRenderFns } from "./Coupons.vue?vue&type=template&id=4864ffd4&scoped=true&"
import script from "./Coupons.vue?vue&type=script&lang=ts&"
export * from "./Coupons.vue?vue&type=script&lang=ts&"
import style0 from "./Coupons.vue?vue&type=style&index=0&id=4864ffd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4864ffd4",
  null
  
)

export default component.exports